/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TerminateTeamMemberRequest
 */
export interface TerminateTeamMemberRequest {
  /**
   *
   * @type {string}
   * @memberof TerminateTeamMemberRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof TerminateTeamMemberRequest
   */
  endDate: LocalDate;
}

/**
 * Check if a given object implements the TerminateTeamMemberRequest interface.
 */
export function instanceOfTerminateTeamMemberRequest(
  value: object,
): value is TerminateTeamMemberRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("endDate" in value) || value["endDate"] === undefined) return false;
  return true;
}

export function TerminateTeamMemberRequestFromJSON(
  json: any,
): TerminateTeamMemberRequest {
  return TerminateTeamMemberRequestFromJSONTyped(json, false);
}

export function TerminateTeamMemberRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TerminateTeamMemberRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    endDate: json["endDate"],
  };
}

export function TerminateTeamMemberRequestToJSON(
  json: any,
): TerminateTeamMemberRequest {
  return TerminateTeamMemberRequestToJSONTyped(json, false);
}

export function TerminateTeamMemberRequestToJSONTyped(
  value?: TerminateTeamMemberRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    endDate: value["endDate"],
  };
}
